module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-shortcuts__container"
  }, [_c('DDropdown', {
    attrs: {
      "isShowDots": false
    }
  }, [_c('div', {
    staticClass: "d-drop-box",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title) + " "), _c('span', {
    staticClass: "icon-arrow-down52"
  })]), _vm._v(" "), _c('ul', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, _vm._l((_vm.shortcuts), function(shortcut) {
    return _c('li', {
      key: shortcut.val,
      on: {
        "click": function($event) {
          return _vm.$emit('shortcutSelected', shortcut.dateRange)
        }
      }
    }, [_vm._v("\n        " + _vm._s(shortcut.title) + "\n      ")])
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-566fb450!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/datepicker/DatePickerRangeShortcuts.vue
// module id = 1928
// module chunks = 1